import { VERIFICATION_FIELDS } from '@/components/InsuranceSection/constants';

export const INSURANCE_POLICY_NOT_MUTABLE_EXEMPT_FIELDS = [
  'back_image_url',
  'front_image_url',
  'plan_end_date',
  'priority_type',
  ...Object.values(VERIFICATION_FIELDS || {})
];
